<template>
  <div class="content_box">
    <div class="nopwd" v-if="setPass!=1">您还未设置过密码，请先设置密码！</div>
    <van-cell-group v-if="setPass==1">
      <van-cell>
        <van-field v-model="oldPassword" type="password" label="原密码" placeholder="请输入原密码" />
      </van-cell>
      <van-cell>
        <van-field v-model="password" type="password" label="新密码" placeholder="请输入新密码" />
      </van-cell>
      <van-cell>
        <van-field v-model="repassword" type="password" label="确认密码" placeholder="请输入确认密码" />
      </van-cell>
    </van-cell-group>
    <van-cell-group v-else>
      <van-cell>
        <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" />
      </van-cell>
      <van-cell>
        <van-field v-model="repassword" type="password" label="确认密码" placeholder="请输入确认密码" />
      </van-cell>
    </van-cell-group>
    <div class="changeStatus" @click="forgetPwd" v-if="setPass==1">忘记密码</div>
    <div
      class="recharge_btn"
      :style="setPass==1?'margin-top:1rem':'margin-top:0.3rem'"
      @click="updatePwd"
    >{{setPass==1?'立即修改':'立即设置'}}</div>
  </div>
</template>

<script>
import { updatePassword } from "@/api/user.js";
import Vue from "vue";
import { Field } from "vant";
import { Cell, CellGroup, Button } from "vant";
import { Notify } from "vant";
import { setToken, getToken } from "@/libs/util.js";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);
export default {
  data() {
    return {
      setPass: 1,
      password: "",
      repassword: "",
      oldPassword: ""
    };
  },
  created() {
    this.setPass = this.$route.query.setPass;
  },
  methods: {
    forgetPwd() {
      this.$router.push({
        path: `/tcmr/forgetPwd`
      });
    },
    updatePwd() {
      let pwdObj = {};
      if (this.setPass == 1) {
        pwdObj = {
          oldPassword: this.oldPassword,
          password: this.password,
          repassword: this.repassword
        };
      } else {
        pwdObj = {
          password: this.password,
          repassword: this.repassword
        };
      }
      updatePassword(pwdObj).then(res => {
        if (res.data.status == 200) {
          Notify({ type: "success", message: "密码修改成功" });
          this.$router.push({
            path: `/tcmr/user`
          });
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    }
  }
};
</script>

<style scoped>
.changeStatus {
  font-size: 0.24rem;
  float: right;
  padding: 0.3rem 0.5rem;
}
.nopwd {
  margin-top: 10px;
  font-size: 0.24rem;
}
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
</style>